import React from 'react';
import { Tag } from 'antd';

export const TASK_PRIORITY_META = {
  high: { color: 'red', text: 'بالا' },
  medium: { color: 'blue', text: 'متوسط' },
  low: { color: 'default', text: 'پایین' },
};

export const TaskPriorityTag = ({ priority }) => {
  const key = (priority || '').toLowerCase();
  const meta = TASK_PRIORITY_META[key] || { color: 'default', text: priority || '—' };
  return (
    <Tag color={meta.color} style={{ fontFamily: 'CustomFont' }}>
      {meta.text}
    </Tag>
  );
};
